export const CITY_COMPARISON_ENDPOINTS = {
  SHARE: "/frontend/create-shared-comparison",
  SHARED_COMPARISON: "/frontend/public/shared-comparison",
  SHARED_COMPARISON_PDF: "/frontend/generate-city-comparison-pdf",
  COMPARISON_TRACK: "/frontend/comparison-analytics/track",
  SESSION_ID: "/frontend/comparison-analytics/session/start",
  EXPORT_ANALYTICS: "/frontend/export-analytics/track",
  POPULAR_WORK_LOCATIONS: "/frontend/popular-work-locations",
};

export default CITY_COMPARISON_ENDPOINTS;
